import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    subjectItems: [],
    subjectTypeItems: [
      {text: 'กลุ่มบังคับ', value: 'MANDATORY'}, 
      {text: 'กลุ่มบังคับเลือก', value: 'ELECTIVE'}
    ]
  },
  getters: {
    subjectItems (state) {
      return state.subjectItems
    },
    subjectTypeItems (state) {
      return state.subjectTypeItems
    }
  },
  mutations: {
    setSubjectItems (state, payload) {
      state.subjectItems = payload
    }
  },
  actions: {
    fetchSubjects ({ commit, dispatch }) {
      console.log('actions fetchSubjects')
      Vue.axios.get(`${config.serverURI}/subjects`).then((response) => {
        console.log('subject', response.data)
        commit('setSubjectItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    fetchSubjectsBySubjectType ({ commit, dispatch }, payload) {
      console.log('actions fetchSubjectsBySubjectType', payload)
      Vue.axios.get(`${config.serverURI}/subjects/findAllBySubjectType/${payload}`).then((response) => {
        console.log('subject -->', response.data)
        commit('setSubjectItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/subjects`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/subjects/page`, { params: pagination })
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/subjects`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/subjects/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/subjects/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/subject.js